export enum DAMAGE_TYPE {
  VALUE,
  STATUS,
}
